"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProgressBar;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AssistiveText = _interopRequireDefault(require("./../AssistiveText"));

var _normalizeValue = _interopRequireDefault(require("./normalizeValue"));

var _container = _interopRequireDefault(require("./styled/container"));

var _bar = _interopRequireDefault(require("./styled/bar"));
/**
 * Progress bar component communicates to the user the progress of a particular process.
 */


function ProgressBar(props) {
  var className = props.className,
      style = props.style,
      assistiveText = props.assistiveText,
      value = props.value,
      size = props.size,
      variant = props.variant;
  var normalizedValue = (0, _normalizeValue["default"])(value);
  var WIDTH = {
    width: "".concat(normalizedValue, "%")
  };
  return _react["default"].createElement(_container["default"], {
    className: className,
    style: style,
    size: size,
    variant: variant,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": normalizedValue,
    role: "progressbar"
  }, _react["default"].createElement(_bar["default"], {
    variant: variant,
    style: WIDTH
  }, _react["default"].createElement(_AssistiveText["default"], {
    text: assistiveText
  })));
}

ProgressBar.propTypes = {
  /** The percentage value of the progress bar. It must be between 0 and 100. */
  value: _propTypes["default"].number,

  /** The size of the progress bar. Valid values are x-small, small, medium, and large.
   * The default value is medium. */
  size: _propTypes["default"].oneOf(['x-small', 'small', 'medium', 'large']),

  /** The variant of the progress bar. Valid values are brand and success. */
  variant: _propTypes["default"].oneOf(['brand', 'success']),

  /** A description for assistive sreen readers. */
  assistiveText: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
ProgressBar.defaultProps = {
  value: 0,
  size: 'medium',
  variant: 'brand',
  assistiveText: '',
  className: undefined,
  style: undefined
};